import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { MatOptionSelectionChange } from "@angular/material/core";
import { FormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { debounceTime, switchMap, tap } from "rxjs/operators";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { GenericComponent } from "../../components/generic.component";
import { VehicleModelService } from "src/app/core/services/vehicle-model.service";
import { VehicleModelDTO } from "../../models/vehicle-model-dto";
import { SearchFormPartsDTO } from "./models/search-form-dto";

@Component({
  selector: "app-smartfleet-vehicle-model-auto-complete-parts",
  templateUrl: "./vehicle-model-auto-complete.component.html",
  styleUrls: ["./vehicle-model-auto-complete.component.scss"],
  standalone: false
})
export class VehicleModelAutoCompletePartsComponent
  extends GenericComponent
  implements OnInit
{
  loading = false;
  _disabled = false;
  name = new FormControl();
  searchForm = this.fb.group({
    name: this.name
  });

  models: VehicleModelDTO[] = [];

  @Input() title = "";
  @Input() page = "";
  @Input() requiredText = "";
  @Input() brandName: string;
  @Output() onChange: any = new EventEmitter<VehicleModelDTO>();
  @Input() set required(value: boolean) {
    if (value && !this._disabled) {
      this.searchForm.get("name").setValidators([Validators.required]);
    }
  }
  @Input() set disabled(value: boolean) {
    this._disabled = value;
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  constructor(
    private vehicleModelService: VehicleModelService,
    injector: Injector,
    private loadingDrivebService: LoadingDrivebService
  ) {
    super(injector);
  }

  ngOnInit() {
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "vehicle":
          key = "vc-vehicleModel";
          break;
        case "maintenance-plan":
          key = "mp-vehicleModel";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        let vehicle = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(vehicle["displayName"]);
      }
    } else {
      this.clean();
    }
    this.name.valueChanges
      .pipe(
        debounceTime(200),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            const filters = {} as SearchFormPartsDTO;
            filters.name = value;
            filters.brandName = this.brandName;
            return this.vehicleModelService.findByFiltersParts(filters);
          } else {
            this.loadingDrivebService.setAutoMode(true);
            this.loading = false;
            this.onChange.emit({} as VehicleModelDTO);
            return new Observable<VehicleModelDTO[]>();
          }
        })
      )
      .subscribe((data) => {
        this.models = data.content;
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
      });
  }

  handleVehicleModelChange(
    event: MatOptionSelectionChange,
    model: VehicleModelDTO
  ) {
    if (event.isUserInput === true) {
      this.onChange.emit(model);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.models = [];
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
    this.models = [];
  }
}
